import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {BsModalRef, BsModalService, ModalOptions} from 'ngx-bootstrap/modal';
import {ActivatedRoute} from "@angular/router";
import { LoadingService } from 'src/app/services/loading/loading.service';
import { DocuSignService } from 'src/app/services/docusign-service/docusign-service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';


@Component({
    selector: 'docusign-modal',
    templateUrl: './docusign-modal.component.html',
    standalone: false
})
  export class DocuSignModalComponent implements OnInit {

    
     constructor(public bsModalRef: BsModalRef, private modalService: BsModalService, private route: ActivatedRoute,
                  public options: ModalOptions, private loader: LoadingService, private docuSignService: DocuSignService, private santizer:DomSanitizer ) {
      }

      embeddUrl: string = '';
      safeUrl!: SafeResourceUrl;
      docMgrId:string ='';

      @ViewChild('iframeRef') iframeRef!: ElementRef;
    
      ngOnInit() {
        this.loader.show();

      /*  this.embeddUrl = Observable.create((observer: any) => {
              this.docuSignService
                .getDocuSignEmbeddUrl()
                .subscribe((result: any) => {
                  observer.next(result);
                });
            });*/
            this.docuSignService.getDocuSignEmbeddUrl(this.docMgrId).subscribe(response => {
                this.embeddUrl = response;
                console.log("embeddUrl:"+this.embeddUrl);
                this.safeUrl = this.santizer.bypassSecurityTrustResourceUrl(this.embeddUrl);
                this.loader.hide();
            })

      /*  this.docuSignService.getDocuSignEmbeddUrl().subscribe(url => {
            this.embeddUrl = url;
            console.log(this.embeddUrl);
          }, (error) => {
            this.loader.hide();
            //this.alertService.error('There was an error retrieving Organization');
          },
        )
        });*/
      }

      onIframeLoad() {
        try {
            const iFrameWindow = this.iframeRef.nativeElement.contentWindow;
            const url = iFrameWindow?.location.href;

            if (url?.includes('docusign-finish')) {
                this.bsModalRef.hide();
            }
        } catch (e) {
            console.log(e);
        }
      }


      makeSelection(confirm: any) {
              this.bsModalRef.hide();
          }
  }